import React, { CSSProperties } from "react";
import { FiPlus } from "react-icons/fi";
import { getThemeColors, getComponentColors, Theme } from "../../theme/colors";

interface NewChatButtonProps {
  isCollapsed: boolean;
  onClick: () => void;
  username: string;
  colorMode: string;
}

export const NewChatButton: React.FC<NewChatButtonProps> = ({
  isCollapsed,
  onClick,
  username,
  colorMode,
}) => {
  const currentColors = getThemeColors(username, colorMode as Theme);
  const sidebarColors = getComponentColors("sidebar", colorMode as Theme);

  const buttonStyle: CSSProperties = {
    borderWidth: "1px",
    borderColor: currentColors.border,
    borderRadius: "4px",
    padding: "0.5rem",
    justifyContent: "flex-start",
    transition: "all ease 0.5s",
    backgroundColor: "transparent",
    cursor: "pointer",
    color: currentColors.text,
    overflow: "hidden",
    whiteSpace: "nowrap",
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  };

  const buttonHoverStyle: CSSProperties = {
    backgroundColor: sidebarColors.buttonHover || currentColors.buttonHover,
  };

  return (
    <div
      style={buttonStyle}
      onClick={onClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor =
          buttonHoverStyle.backgroundColor || "";
      }}
      onMouseLeave={(e) =>
        (e.currentTarget.style.backgroundColor = "transparent")
      }
      title={isCollapsed ? "New Chat" : undefined}
    >
      <FiPlus size={16} />
      {!isCollapsed && <span>New Chat</span>}
    </div>
  );
};
